import { Fragment } from 'react';
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { ScaffolderStyles } from './scaffolder/ScaffolderStyles';

// `sub-page:scaffolder/templates` : la sous-page native ne transmet au
// formulaire ni l'étape de revue ni les mises en page personnalisées, que ce
// projet remplace tous les deux. Elle est remplacée par la nôtre, construite
// avec les composants publics du scaffolder (voir `PlatformTemplatesSubPage`).
const templatesSubPage = scaffolderPlugin
  .getExtension('sub-page:scaffolder/templates')
  .override({
    params: {
      loader: () =>
        import('./scaffolder/PlatformTemplatesSubPage').then(m => (
          <m.PlatformTemplatesSubPage />
        )),
    },
  });

// Sas de démarrage d'un wizard, hors de `/create` à dessein : y passer
// démonte le wizard précédent, ce qui garantit un formulaire vierge. Voir
// `StartTemplate.tsx`. Le chemin est aussi écrit en littéral dans la barre
// latérale de l'application (lien « Créer un service ») : à garder aligné.
const startTemplatePage = PageBlueprint.make({
  name: 'start-template',
  params: {
    path: '/new/:templateName',
    title: 'Nouveau',
    noHeader: true,
    loader: () =>
      import('./scaffolder/StartTemplate').then(m => <m.StartTemplate />),
  },
});

// Wrapper qui enveloppe la mise en page — le point d'accroche natif pour un
// sidecar sans rendu propre. `ScaffolderStyles` ne retourne jamais rien
// (`return null`) : il ne fait que surveiller la route courante
// (`useLocation`) pour (dé)poser une classe sur `document.body`. Il doit
// rester monté inconditionnellement, d'où son insertion ici plutôt que dans
// les routes. Pas de `compatWrapper` : ce composant n'utilise que des hooks
// React/react-router, sans dépendance à la résolution d'API v1.
const scaffolderStyles = AppRootWrapperBlueprint.make({
  name: 'styles',
  params: {
    component: ({ children }) => (
      <Fragment>
        <ScaffolderStyles />
        {children}
      </Fragment>
    ),
  },
});

export default createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [templatesSubPage, startTemplatePage, scaffolderStyles],
});
